import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=4f21713a&scoped=true"
import script from "./SideNav.vue?vue&type=script&lang=ts"
export * from "./SideNav.vue?vue&type=script&lang=ts"
import style0 from "./SideNav.vue?vue&type=style&index=0&id=4f21713a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f21713a",
  null
  
)

export default component.exports